import * as React from 'react';
import ReactDom from 'react-dom/client';
import { type iModal, type modalId } from './types';

export class ModalContainer extends React.Component<any> {
    state: any = {
        modalList: [],
    };

    // 用列表存储模态框数据
    showDialog = (modal: iModal) => {
        this.state.modalList.push(modal);
        this.setState({
            modalList: this.state.modalList,
        });
    };

    // 根据id删除模态框
    removeDialog = (id: modalId) => {
        const modalList = this.state.modalList.filter((modal: iModal) => modal.id !== id);
        this.setState({ modalList: modalList || [] });
    };

    // 删除所有模态框
    removeAll = () => {
        this.setState({
            modalList: [],
        });
    };

    // todo: 自定义模态框事件映射
    eventListener = (type: any, param: any) => {
        // eslint-disable-next-line eqeqeq
        if (type == 'closeModal') {
            this.removeDialog(param);
        }
    };

    render() {
        return (
            <div className="modal">
                {this.state.modalList.map(({ id, option }: iModal) => {
                    const { Dialog, config } = option;
                    return <Dialog key={id} id={id} config={config} onTrigger={this.eventListener} />;
                })}
            </div>
        );
    }
}

// 动态创建dom容器
function getModalContainer(ModalContainer: React.ComponentClass) {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const root = ReactDom.createRoot(div);
    const ref = React.createRef<ModalContainer>();

    root.render(<ModalContainer ref={ref} />);

    // Ensure instance is accessible after render completes
    return new Promise<ModalContainer>((resolve) => {
        const checkRef = () => {
            if (ref.current) {
                resolve(ref.current);
            } else {
                setTimeout(checkRef, 0); // Retry until ref is available
            }
        };
        checkRef();
    });
}

// 暴露类实例
export default getModalContainer;
